import { CALL_API } from '../middleware/api'

export const BATTERIES_REQUEST = 'BATTERIES_REQUEST'
export const BATTERIES_SUCCESS = 'BATTERIES_SUCCESS'
export const BATTERIES_FAILURE = 'BATTERIES_FAILURE'

export function fetchBatteries(machine, customer, startDate, endDate) {
  let params = ''

  if (machine) {
    params += `&Machine=${machine}`
  }

  if (customer) {
    params += `&Customer=${customer}`
  }

  if (startDate) {
    params += `&StartDate=${startDate}`
  }

  if (endDate) {
    params += `&EndDate=${endDate}`
  }

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `batteries?${params}`,
      authenticated: true,
      types: [BATTERIES_REQUEST, BATTERIES_SUCCESS, BATTERIES_FAILURE]
    }
  }
}
